import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d9b0f10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-fold-panel" }
const _hoisted_2 = { class: "tir-pm-fold-panel__content" }

import { ChevronDownIcon } from "tir-style-system/icons/outline";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmFoldPanel',
  props: {
  /**Видимость складной панели*/
  isVisible: { type: Boolean, default: false },
},
  emits: ["toggle"],
  setup(__props, { emit }) {


/**События */


/**Переключение видимости складной панели */
const toggle = () => {
  emit("toggle");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "tir-pm-fold-panel__header",
      onClick: toggle
    }, [
      _renderSlot(_ctx.$slots, "header"),
      _createVNode(_unref(ChevronDownIcon), {
        class: _normalizeClass(["tir-pm-fold-panel__icon", { 'tir-pm-fold-panel__icon--open': __props.isVisible }])
      }, null, 8, ["class"])
    ]),
    _createVNode(_Transition, { name: "fold" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "content")
        ], 512), [
          [_vShow, __props.isVisible]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})